import type { KeyboardEvent, ReactNode } from "react";
import clsx from "clsx";
import "./document-file-name.scss";

type DocumentFileNameProps = {
  children: ReactNode;
  className?: string;
  title?: string;
  onClick?: () => void;
  disabled?: boolean;
  variant?: "link" | "plain";
};

export function DocumentFileName({
  children,
  className,
  title,
  onClick,
  disabled = false,
  variant = "link",
}: DocumentFileNameProps) {
  if (!onClick) {
    return (
      <span className={clsx("document-file-name", className)} title={title}>
        {children}
      </span>
    );
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <button
      type="button"
      className={clsx(
        "document-file-name",
        "document-file-name--clickable",
        variant === "plain" && "document-file-name--plain",
        className,
      )}
      title={title}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
